import { formatarNumero_recebido_com_casa_decimais, formatarNumero_recebido_sem_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

export function formatar_numeros_cabecalho_5B(item: any) {
    return {
        ...item,
        area: formatarNumero_recebido_com_casa_decimais(item.area),
        esperada: formatarNumero_recebido_com_casa_decimais(item.esperada),
        obtida: formatarNumero_recebido_com_casa_decimais(item.obtida),
        parcela_numero: formatarNumero_recebido_com_casa_decimais(item.parcela_numero),
        sub_parcela: formatarNumero_recebido_com_casa_decimais(item.sub_parcela),
        profundidade: formatarNumero_recebido_sem_casa_decimais(item.profundidade),
        n_amostras: formatarNumero_recebido_sem_casa_decimais(item.n_amostras),
        n_boletim:formatarNumero_recebido_sem_casa_decimais(item.n_boletim),
    };
}

export function formatar_numeros_Analise_Terra_5B(item: any) {
    return {
        ...item,
        mg_camp1: formatarNumero_recebido_com_casa_decimais(item.mg_camp1),
        mg_camp2: formatarNumero_recebido_com_casa_decimais(item.mg_camp2),
        mg_camp3: formatarNumero_recebido_com_casa_decimais(item.mg_camp3),
        mg_camp4: formatarNumero_recebido_com_casa_decimais(item.mg_camp4),
        mg_camp5: formatarNumero_recebido_com_casa_decimais(item.mg_camp5),
        mg_camp6: formatarNumero_recebido_com_casa_decimais(item.mg_camp6),
        percentagem_camp1: formatarNumero_recebido_com_casa_decimais(item.percentagem_camp1),
        percentagem_camp2: formatarNumero_recebido_com_casa_decimais(item.percentagem_camp2),
        percentagem_camp3: formatarNumero_recebido_com_casa_decimais(item.percentagem_camp3),
        percentagem_camp4: formatarNumero_recebido_com_casa_decimais(item.percentagem_camp4),
        percentagem_camp5: formatarNumero_recebido_com_casa_decimais(item.percentagem_camp5),
        percentagem_camp6: formatarNumero_recebido_com_casa_decimais(item.percentagem_camp6),
        Resultados_analicesPH: formatarNumero_recebido_com_casa_decimais(item.Resultados_analicesPH),
        Resultados_analicesMO: formatarNumero_recebido_com_casa_decimais(item.Resultados_analicesMO),
        deduzir_cálculo: formatarNumero_recebido_com_casa_decimais(item.deduzir_cálculo)
    };
}

export function formatar_numeros_Atividades_5B(item: any) {
    return {
        ...item,
        t: formatarNumero_recebido_com_casa_decimais(item.t),
        n: formatarNumero_recebido_com_casa_decimais(item.n),
        po: formatarNumero_recebido_com_casa_decimais(item.po),
        ko: formatarNumero_recebido_com_casa_decimais(item.ko),
        mgo: formatarNumero_recebido_com_casa_decimais(item.mgo),
        cao: formatarNumero_recebido_com_casa_decimais(item.cao),
        so: formatarNumero_recebido_com_casa_decimais(item.so),
        b: formatarNumero_recebido_com_casa_decimais(item.b),
    };
}

export  function formatar_numeros_Atividades_ExtraTabela_5B(item: any) {
    return {
      ...item,
      elementos_n: formatarNumero_recebido_com_casa_decimais(item.elementos_n),
      elementos_po: formatarNumero_recebido_com_casa_decimais(item.elementos_po),
      elementos_ko: formatarNumero_recebido_com_casa_decimais(item.elementos_ko),
      elementos_mgo: formatarNumero_recebido_com_casa_decimais(item.elementos_mgo),
      elementos_cao: formatarNumero_recebido_com_casa_decimais(item.elementos_cao),
      elementos_so: formatarNumero_recebido_com_casa_decimais(item.elementos_so),
      elementos_b: formatarNumero_recebido_com_casa_decimais(item.elementos_b),
      totais_apli_homo_n: formatarNumero_recebido_com_casa_decimais(item.totais_apli_homo_n),
      totais_apli_homo_po: formatarNumero_recebido_com_casa_decimais(item.totais_apli_homo_po),
      totais_apli_homo_ko: formatarNumero_recebido_com_casa_decimais(item.totais_apli_homo_ko),
      totais_apli_homo_mgo: formatarNumero_recebido_com_casa_decimais(item.totais_apli_homo_mgo),
      totais_apli_homo_cao: formatarNumero_recebido_com_casa_decimais(item.totais_apli_homo_cao),
      totais_apli_homo_so: formatarNumero_recebido_com_casa_decimais(item.totais_apli_homo_so),
      totais_apli_homo_b: formatarNumero_recebido_com_casa_decimais(item.totais_apli_homo_b),
      totais_apli_n: formatarNumero_recebido_com_casa_decimais(item.totais_apli_n),
      totais_apli_po: formatarNumero_recebido_com_casa_decimais(item.totais_apli_po),
      totais_apli_ko: formatarNumero_recebido_com_casa_decimais(item.totais_apli_ko),
      totais_apli_mgo: formatarNumero_recebido_com_casa_decimais(item.totais_apli_mgo),
      totais_apli_cao: formatarNumero_recebido_com_casa_decimais(item.totais_apli_cao),
      totais_apli_so: formatarNumero_recebido_com_casa_decimais(item.totais_apli_so),
      totais_apli_b: formatarNumero_recebido_com_casa_decimais(item.totais_apli_b),
    };
  }